class Product {
    constructor() {
        this.options = {
            activeClass: 'active',
            hiddenClass: '!hidden',
            productInfoSelector: 'product-info',
            buyButtonsSelector: 'product-info .buy-buttons',
            buyButtonsStickySelector: 'product-info .buy-buttons-sticky',
            collapsibleSelector: 'product-info .collapsible'
        };

        this.initCollapsibles();
        this.initStickyBuyButtons();
        this.initStickyProductInfo();
    }

    initCollapsibles() {
        const collapsibles = document.querySelectorAll(this.options.collapsibleSelector);

        if (!collapsibles.length) return;

        collapsibles.forEach(wrapper => {
            const trigger = wrapper.querySelector('[data-trigger]');
            const content = wrapper.querySelector('[data-content]');

            trigger.addEventListener('click', () => {
                wrapper.classList[wrapper.classList.contains(this.options.activeClass) ? 'remove' : 'add'](this.options.activeClass);
                content.classList[content.classList.contains(this.options.hiddenClass) ? 'remove' : 'add'](this.options.hiddenClass);
            });
        });
    }

    initStickyBuyButtons() {
        const buyButtons = document.querySelector(this.options.buyButtonsSelector);
        const buyButtonsSticky = document.querySelector(this.options.buyButtonsStickySelector);

        if (!buyButtons || !buyButtonsSticky) return;

        const footer = document.querySelector('footer');
        const buyButtonsBottomPosition = buyButtons.offsetTop + buyButtons.offsetHeight;

        window.addEventListener('scroll', () => {
            buyButtonsSticky.classList[window.scrollY >= buyButtonsBottomPosition ? 'add' : 'remove'](this.options.activeClass);
            footer.style.cssText = window.scrollY >= buyButtonsBottomPosition ? `padding-bottom: ${ buyButtonsSticky.offsetHeight }px` : '';
        });
    }

    initStickyProductInfo() {
        const productInfo = document.querySelector(this.options.productInfoSelector);

        let productInfoHeight = productInfo.offsetHeight,
            screenHeight = window.innerHeight,
            startScroll = parseInt(window.getComputedStyle(productInfo).top, 10),
            endScroll = window.innerHeight - productInfoHeight,
            currPos = window.scrollY;

        productInfo.style.top = `${ startScroll }px`;

        const productInfoResizeListener = () => {
            productInfoHeight = productInfo.offsetHeight;
            screenHeight = window.innerHeight;
        }

        const productInfoScrollListener = () => {
            productInfoHeight = productInfo.offsetHeight;

            if (productInfoHeight <= screenHeight) {
                productInfo.style.top = `${ startScroll }px`;

                return;
            }

            endScroll = window.innerHeight - productInfo.offsetHeight;

            let productInfoTop = parseInt(productInfo.style.top, 10);

            if (productInfoHeight > screenHeight){
                if (window.scrollY < currPos) {
                    if (productInfoTop < startScroll) {
                        productInfo.style.top = `${ productInfoTop + currPos - window.scrollY }px`;
                    } else if (productInfoTop >= startScroll && productInfoTop !== startScroll) {
                        productInfo.style.top = `${ startScroll }px`;
                    }
                } else {
                    if (productInfoTop > endScroll) {
                        productInfo.style.top = `${ productInfoTop + currPos - window.scrollY }px`;
                    } else if (productInfoTop < (endScroll) && productInfoTop !== endScroll) {
                        productInfo.style.top = `${ endScroll }px`;
                    }
                }
            }

            currPos = window.scrollY;
        }

        window.addEventListener('resize', productInfoResizeListener);
        window.addEventListener('scroll', () => {
            if (window.innerWidth >= 768) productInfoScrollListener();
        }, { capture: true, passive: true });
    }
}

document.addEventListener('DOMContentLoaded', () => new Product());
